// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UnF0","right":"styles_right__3DF9K"};